// extracted by mini-css-extract-plugin
export default {"Box":"CompanyKYC_Box__GAFpO","Title":"CompanyKYC_Title__p1LPm","SubTitle":"CompanyKYC_SubTitle__NAVJa","Separator":"CompanyKYC_Separator__LkUzN"};